import { FormInput } from "../../../helpers/AdminHelper";
import { memo } from "react";

const BasicProjectInfo = ({ project, updateProject, inputClass }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-white">Basic Information</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormInput
          label="Project Title"
          className={inputClass}
          placeholder="Corporate Office Security Installation"
          value={project.title}
          onChange={(e) => updateProject("title", e.target.value)}
        />

        <FormInput
          label="Slug"
          className={inputClass}
          placeholder="corporate-office-security-installation"
          value={project.slug}
          onChange={(e) => updateProject("slug", e.target.value)}
        />

        <FormInput
          label="Category"
          className={inputClass}
          placeholder="Corporate Security"
          value={project.category}
          onChange={(e) => updateProject("category", e.target.value)}
        />

        <FormInput
          label="Client Name"
          className={inputClass}
          placeholder="ABC Pvt Ltd"
          value={project.clientName}
          onChange={(e) => updateProject("clientName", e.target.value)}
        />

        <FormInput
          label="Location"
          className={inputClass}
          placeholder="New Delhi"
          value={project.location}
          onChange={(e) => updateProject("location", e.target.value)}
        />

        <FormInput
          label="Project Duration"
          className={inputClass}
          placeholder="3 Months"
          value={project.projectDuration}
          onChange={(e) => updateProject("projectDuration", e.target.value)}
        />

        <div>
          <label className="block mb-2 text-sm font-medium">Status</label>

          <select
            className={inputClass}
            value={project.status}
            onChange={(e) => updateProject("status", e.target.value)}
          >
            <option value="completed" className="bg-[#0a0f1a] text-white">
              Completed
            </option>

            <option value="ongoing" className="bg-[#0a0f1a] text-white">
              Ongoing
            </option>

            <option value="upcoming" className="bg-[#0a0f1a] text-white">
              Upcoming
            </option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default memo(BasicProjectInfo);
